import { defineMessages } from 'react-intl';

const messages = defineMessages({
  label: {
    id: 'dossier.statusFilter.label',
    defaultMessage: 'Statut',
  },
  all: {
    id: 'dossier.statusFilter.all',
    defaultMessage: 'Tous les statuts',
  },
});

export default messages;
